<template>
  <div>
    <div id="season-body">
      <transition :name="isMobile?'fade':'slide-fade'" mode="out-in" v-if="dataLoaded.user && profile.datas.ongoing_season_obj !== null" appear>
        <card :key="currentSeason.id"></card>
      </transition>
      <div v-else-if="dataLoaded.user" class="clickable" style="color: var(--navBackgroundColor)" @click="$router.push({name: 'catalog'})">
        <h1>Clique ici pour choisir une série dans notre catalogue</h1>
      </div>
      <div v-else>
        <loading-logo></loading-logo>
      </div>


        <div v-if="!isMobile" style="height: 7vw">
          <transition name="fadedown" mode="out-in" v-if="appStep === states.MENU">
            <learnt-words-section
                :number-words="7">
            </learnt-words-section>
          </transition>
          <div v-else-if="appStep === states.ONGOING_SESSION" class="subtitles"
               @click="subtitlesOn = !subtitlesOn">
            <div v-if="!subtitlesOn">
              <p>Activer les sous-titres</p>
            </div>
            <Subtitles v-else></Subtitles>
          </div>
        </div>


    </div>
  </div>


</template>

<script>
import {API_URL} from "@/App";
import axios from "axios";
import {mapGetters, mapActions} from 'vuex'
import LoadingLogo from "@/components/loadingLogo";

export default {
  name: "seasonCard",

  components: {
    LoadingLogo,
    LearntWordsSection: () => import(/* webpackPrefetch: true */ '@/components/learntWordsSection.vue'),
    card: () => import(/* webpackPrefetch: true */ '@/components/card.vue'),
    Subtitles: () => import(/* webpackPrefetch: true */ '@/components/subtitles.vue'),
  },

  created() {
    // Si les données utilisateurs sont déjà chargées, mais que currentSeason ne l'est pas, on récupère la saison en cours de l'utilisateur
    // Sinon ces données seront récupérées dans un watch sur les données utilisateurs
    if(this.dataLoaded.user && !this.currentSeason.loaded) {
      this.getSeasonData(this.profile.datas.ongoing_season_obj.id)
      //this.set_seasonRequested(this.profile.datas.ongoing_season_obj.id)
    }
  },

  computed: {
    ...mapGetters('global', [
        'isMobile', 'appStep',
        'states',
        'profile',
        'dataLoaded',
        'dataReload',
        'seasonsData',
        'showsData',
        'routeName'
    ]),
    ...mapGetters('show', [
        'currentShow',
        'currentSeason',
        'seasonRequested'
    ]),
  },

  methods: {
    ...mapActions('global', [
        'update_showsData',
        'update_seasonsData',
        'set_appStep'
    ]),
    ...mapActions('show', [
        'set_currentShow',
        'set_currentSeason',
        'set_currentSeasonLoaded',
        'set_seasonRequested',
        'set_currentWordsLearnt',
        'set_wordsLearntLoaded',
    ]),

    getSeasonData(seasonId) {
      if(this.seasonsData.hasOwnProperty(seasonId)){
        this.set_currentSeason(this.seasonsData[seasonId]);
        if(this.showsData.hasOwnProperty(this.seasonsData[seasonId].show_id)){
          this.set_currentShow(this.showsData[this.seasonsData[seasonId].show_id]);
        }
      }

      this.set_wordsLearntLoaded(false)
      this.set_currentSeasonLoaded(false)
      let url = `${API_URL}/api/season/`
      let lastRequest = seasonId
      this.$webAuth.checkSession({}, (error, authResult) => {
        if(!error) {
          axios.get(url + seasonId + '/', {headers: {Authorization: `Bearer ${authResult.accessToken}`}})
              .then(response => {
                return response.data;
              })
              .then(data => {
                    if (lastRequest === data.id) {
                      this.update_showsData(
                          {
                            id: data.show_id,
                            data: data.show
                          }
                      )
                      delete data['show']
                      this.update_seasonsData(
                          {
                            id: seasonId,
                            data: data
                          }
                      )

                      this.set_currentShow(this.showsData[this.seasonsData[seasonId].show_id]);
                      this.set_currentSeason(this.seasonsData[seasonId]);
                      this.set_currentSeasonLoaded();
                    }

                  }
              );

          url = `${API_URL}/api/words_learnt/`
          if (seasonId != undefined) {
            axios.get(url + seasonId + '/', {headers: {Authorization: `Bearer ${authResult.accessToken}`}})
                .then(response => {
                  return response.data;
                })
                .then(data => {
                  this.set_currentWordsLearnt(data)
                  this.set_wordsLearntLoaded(true)
                });
          }
        }
        else {
          console.log(error)
        }
      });
    }
  },

  watch:{
    'dataLoaded.user': function() {
      if(this.profile.datas.ongoing_season_obj !== null) {
        this.getSeasonData(this.profile.datas.ongoing_season_obj.id)
      }
    },

    /*'currentSeason.id': function() {
      this.getSeasonData(this.profile.datas.ongoing_season_obj.id)
    },*/

    'dataReload': function() {
      this.getSeasonData(this.currentSeason.id)
    },

    'seasonRequested': function() {
      this.getSeasonData(this.seasonRequested)
    }
  },

  data() {
    return {
      subtitlesOn: true
    }
  }
}
</script>

<style scoped>
 #season-body {
   position: relative;
   height: calc(100% - 2vw);
   display: flex;
   flex-wrap: wrap;
   flex-direction: column;
   justify-content: center;
   justify-items: center;
   align-content: center;
   align-items: center;
   margin-bottom: 2vw;

 }

 .backArrow {
   position: absolute;
   top: 5px;
   left: 5px;
 }

 .subtitles {
   width: 100%;
   height: 100%;
   /*position: absolute;*/
   bottom: 10vw;
   left: 0;
   text-align: center;
   font-family: 'Open Sans';
   font-size: 150%;
   font-weight: bold;
   text-shadow: 0.1vw 0.1vw #000, -0.1vw -0.1vw #000, -0.1vw 0.1vw #000, 0.1vw -0.1vw #000,
   0.14vw 0px #000, -0.14vw -0px #000, -0.14vw 0px #000, 0.14vw -0px #000,
   0px 0.14vw #000, -0px -0.14vw #000, -0px 0.14vw #000, 0px -0.14vw #000;
   letter-spacing: 0.08vw;
   align-content: center;
   display: flex;
 }

 @media screen and (max-device-width: 767px) {
   #season-body {
     height: 100%;
     margin-bottom: 0;
   }
   .subtitles {
     text-shadow: 0.3vw 0.3vw #000, -0.3vw -0.3vw #000, -0.3vw 0.3vw #000, 0.3vw -0.3vw #000,
     0.5vw 0px #000, -0.5vw -0px #000, -0.5vw 0px #000, 0.5vw -0px #000,
     0px 0.5vw #000, -0px -0.5vw #000, -0px 0.5vw #000, 0px -0.5vw #000;
     letter-spacing: 0.32vw;
   }
 }
</style>